import { ACTION_MAP } from "@app/lib/actions";
import Alpine from "alpinejs";

type State<Data> = {
  action: string;
  event: string;
  data: Data;
  submitting: boolean;
  response: Response | undefined;
  error: Error | undefined;
};

Alpine.data("form", <Data>(action: string, initialData: Data) => {
  const state: State<Data> = {
    action,
    event: "",
    data: initialData,
    submitting: false,
    response: undefined,
    error: undefined,
  };

  return {
    ...state,

    // Event Handlers
    async handleSubmit(event: SubmitEvent) {
      event.preventDefault();
      if (!event.target || !event.currentTarget) return;
      this.submitting = true;
      this.error = undefined; // remove the error message on resubmit.
      try {
        this.response = await ACTION_MAP[this.action](this.data);
      } catch (error) {
        this.error = error as Error;
      } finally {
        this.submitting = false;
      }
    },

    async handleButtonSubmit(e: Event) {
      e?.preventDefault();
      const element = e.currentTarget;
      this.error = undefined; // remove the error message on resubmit.

      try {
        const action = element.value;
        const dataset = element.dataset;
        this.response = await ACTION_MAP[action]({
          ...this.data,
          submit: dataset,
        });
      } catch (error) {
        this.error = error as Error;
      }
    },

    // Lifecycle Hooks

    init() {
      Alpine.bind(this.$root, this.root);
    },

    // Bound Directives
    root: {
      ["@submit"](event: SubmitEvent) {
        this.handleSubmit(event);
      },
      [":data-ui"]() {
        if (this.submitting) return "loading";
        return "";
      },
    },
    ["submit"]: {
      ["@click"](e: Event) {
        this.handleButtonSubmit(e);
      },
    },
  };
});
